import { MAX_NAME_AMOUNT } from './constants'

class StringUtils {
  static getFirstNameLastName(value: string) {
    const arrayName = value.split(' ')
    const result = arrayName.length >= MAX_NAME_AMOUNT ? MAX_NAME_AMOUNT : 1
    const valueName = arrayName.slice(0, result).join(' ')

    return valueName
  }

  static getFirstLettersName(value: string) {
    const valueName = this.getFirstNameLastName(value)
    const arrayName = valueName.split(' ')
    const firstLetter = arrayName[0]
    const lastLetter = arrayName[1]

    const firstLetters =
      arrayName.length === MAX_NAME_AMOUNT
        ? `${firstLetter[0]}${lastLetter[0]}`
        : `${firstLetter[0]}`

    return firstLetters
  }
}

export default StringUtils
